import { useContext } from 'react';

import AssigneeFilter from '@atom/components/common/assigneeFilter/AssigneeFilter';

import WorkOrdersFiltersContext from './WorkOrdersFiltersContext';

const TeamAssignedToFilter = () => {
  const { areFiltersDisabled, filterForm, updateFilterForm } = useContext(
    WorkOrdersFiltersContext,
  );

  const { teamAssignedToGroupIds, teamAssignedToUserIds } = filterForm;

  const onChange = (userIds: string[], groupIds: string[]) => {
    updateFilterForm('teamAssignedToUserIds', userIds);
    updateFilterForm('teamAssignedToGroupIds', groupIds);
  };

  return (
    <AssigneeFilter
      userIds={teamAssignedToUserIds}
      groupIds={teamAssignedToGroupIds}
      onChange={onChange}
      disabled={areFiltersDisabled}
      dataCy="workOrdersFilterAssignedToInput"
    />
  );
};

export default TeamAssignedToFilter;
